export default __webpack_public_path__ + "static/media/proximanova-semibold-webfont.f92cb73a.woff";